const nodes = [
    { id: "neuro", title: "Neuro:", text: "Understanding the addictive loop", pos: "left-1/2 top-0 -translate-x-1/2" },
    { id: "spiritual", title: "Spiritual:", text: "Divine intervention", pos: "right-0 top-1/2 -translate-y-1/2" },
    { id: "healing", title: "Healing:", text: "Total Reconstruction of self", pos: "left-1/2 bottom-0 -translate-x-1/2" },
    { id: "clinical", title: "Clinical:", text: "Behavioral-Patterns Impulse control", pos: "left-0 top-1/2 -translate-y-1/2" },
];

export const NcsDiagram = () => (
    <div data-testid="ncs-diagram" className="relative mx-auto h-[340px] w-[300px] sm:h-[400px] sm:w-[360px]">
        <div className="absolute inset-8 rounded-full border border-[#C9A227]/35" />
        <div className="absolute left-1/2 top-1/2 z-10 flex h-28 w-28 -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full border-2 border-[#C9A227] bg-[#0B1F3A] text-center shadow-[0_0_50px_-10px_rgba(201,162,39,0.55)] sm:h-32 sm:w-32">
            <span className="text-lg font-extrabold text-white sm:text-xl">NCS</span>
            <span className="text-[9px] font-bold tracking-[0.2em] text-[#D4AF37] sm:text-[10px]">FRAMEWORK</span>
        </div>
        {nodes.map((n) => (
            <div
                key={n.id}
                data-testid={`ncs-node-${n.id}`}
                className={`absolute ${n.pos} flex h-[104px] w-[104px] flex-col items-center justify-center rounded-full border border-[#C9A227]/50 bg-[#122B4A]/90 p-3 text-center backdrop-blur-sm transition-transform duration-300 hover:scale-105 sm:h-32 sm:w-32`}
            >
                <span className="text-[11px] font-bold text-[#D4AF37] sm:text-xs">{n.title}</span>
                <span className="mt-0.5 text-[9px] leading-tight text-white/85 sm:text-[10px]">{n.text}</span>
            </div>
        ))}
    </div>
);
